import { render, staticRenderFns } from "./acts-group-item.vue?vue&type=template&id=21b6ea42"
import script from "./acts-group-item.vue?vue&type=script&lang=js"
export * from "./acts-group-item.vue?vue&type=script&lang=js"
import style0 from "./acts-group-item.vue?vue&type=style&index=0&id=21b6ea42&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports